var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

var Popper = require('popper.js').default;
window.Popper = Popper;
// window.define = undefined;

// bootstrap imported via material theme
// require('bootstrap');
// require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
// require('bootstrap/js/dist/util');
// require('bootstrap/js/dist/collapse');
// require('bootstrap/js/dist/dropdown');
// require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
// require('bootstrap/js/dist/tab');
// require('bootstrap/js/dist/tooltip');

// require('bootstrap-datepicker');
require('bootstrap-material-design');
require('bootstrap-select');
require('ekko-lightbox');
var cookie = require('js-cookie');

// require('jquery.placeholder');
require('jquery-sticky');
require('jquery-freeze-table');
// require('freezetable/dist/js/freeze-table.js');
// require('jquery-match-height');

require('owl.carousel');
require('magnific-popup');
// require('lazysizes');
// require('picturefill');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded


window.$.fn.selectpicker.Constructor.BootstrapVersion = '4';

$(function() {

    $('body').bootstrapMaterialDesign();

    scrollToFormError();
    // $('.nav-link').button('dispose')
    // Initialise the Ajax funxctions - put most of your js calls in this function
    // or if you need to reload them after an ajax call
    initAjaxJS();

    // $(window).load(function() {
    // });

    $('.freeze-table').freezeTable({
        // 'columnNum': 2
        freezeHead:true,
        freezeColumn:true,
        columnNum: 3,
        scrollable: true,


    });

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
        event.preventDefault();
        $(this).ekkoLightbox({
            alwaysShowClose: true,
        });
    });


    $('.selectpicker').selectpicker();

    // $('#login-modal').on('shown.bs.modal', function() {
    //     $('#email').trigger('focus')
    // })


    // placeholder polyfill for browsers that need it
    // $('input, textarea').placeholder();


    // Off canvas mobile nav
    $('[data-toggle="offcanvas"]').click(function() {
        $('.sidebar-offcanvas').toggleClass('active');
        $(this).toggleClass('close-btn')

    });

    if ($('.main-slider').length) {
        $('.main-slider').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: false,
            dots: false,
            autoplay: false,
            autoplayTimeout: 10000,
            smartSpeed: 750,
            animateOut: 'slideOutUp',
            animateIn: 'slideInUp',
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            freeDrag: false,
            responsive: {

                0: {

                },

                576: {

                },
                768: {
                    dots: true
                }
            }

        })
    }

    if ($('.testimonial-carousel').length) {
        $('.testimonial-carousel').owlCarousel({
            responsiveRefreshRate: 1,
            loop: true,
            margin: 0,
            responsiveClass: true,
            items: 1,
            nav: false,
            dot: true,
            autoplay: true,
            autoplayTimeout: 12000,
            smartSpeed: 750

        })
    }

    if ($('.products-carousel').length) {
        $('.products-carousel').owlCarousel({
            responsiveRefreshRate: 1,
            loop: false,
            responsiveClass: true,
            margin: 30,
            dots: true,
            autoplay: false,
            center: false,
            autoplayTimeout: 6000,
            items: 6,
            smartSpeed: 750,
            responsive: {

                0: {
                    items: 1
                },

                576: {
                    items: 2
                },
                768: {
                    margin: 40,
                    items: 3,
                    dots: true
                },
                992: {
                    items: 3
                },
                1200: {
                    items: 4
                },
                1440: {
                    items: 5
                },
                1560: {
                    items: 6
                }
            }

        })
    }


    var bigimage = $("#big");
    var thumbs = $("#thumbs");
    //var totalslides = 10;
    var syncedSecondary = true;

    bigimage
        .owlCarousel({
            items: 1,
            slideSpeed: 2000,
            nav: true,
            autoplay: true,
            dots: false,
            loop: true,
            responsiveRefreshRate: 200,
            navText: [
                '<i class="fa fa-arrow-left" aria-hidden="true"></i>',
                '<i class="fa fa-arrow-right" aria-hidden="true"></i>'
            ]
        })
        .on("changed.owl.carousel", syncPosition);

    thumbs
        .on("initialized.owl.carousel", function() {
            thumbs
                .find(".owl-item")
                .eq(0)
                .addClass("current");
        })
        .owlCarousel({
            items: 4,
            dots: true,
            nav: true,
            navText: [
                '<i class="fa fa-arrow-left" aria-hidden="true"></i>',
                '<i class="fa fa-arrow-right" aria-hidden="true"></i>'
            ],
            smartSpeed: 200,
            slideSpeed: 500,
            slideBy: 4,
            responsiveRefreshRate: 100
        })
        .on("changed.owl.carousel", syncPosition2);

    function syncPosition(el) {
        //if loop is set to false, then you have to uncomment the next line
        //var current = el.item.index;

        //to disable loop, comment this block
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }
        //to this
        thumbs
            .find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
        var onscreen = thumbs.find(".owl-item.active").length - 1;
        var start = thumbs
            .find(".owl-item.active")
            .first()
            .index();
        var end = thumbs
            .find(".owl-item.active")
            .last()
            .index();

        if (current > end) {
            thumbs.data("owl.carousel").to(current, 100, true);
        }
        if (current < start) {
            thumbs.data("owl.carousel").to(current - onscreen, 100, true);
        }
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            bigimage.data("owl.carousel").to(number, 100, true);
        }
    }

    thumbs.on("click", ".owl-item", function(e) {
        e.preventDefault();
        var number = $(this).index();
        bigimage.data("owl.carousel").to(number, 300, true);
    });



    $('.scrollup').click(function() {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });

    if ($('.down-scroll').length) {
        // Page scroll
        $('.down-scroll').bind('click', function(event) {
            var $anchor = $(this);

            $('html, body').stop().animate({
                scrollTop: $($anchor.attr('href')).offset().top - 104
            }, 500, 'easeInOutExpo');

            event.preventDefault();
        });
    }


    $(window).scroll(function() {
        if ($(this).scrollTop() > 125) {
            $('#main-nav').addClass('page-down');
        } else {
            $('#main-nav').removeClass('page-down');
        }
    });



    if ($('.popup-gallery').length) {
        $('.popup-gallery').magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
            gallery: {
                enabled: true
            },
        });
    }

    $('.popup-youtube').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        gallery: {
            enabled: true
        },
    });

    var owl = $('.sq-carousel');
    owl.owlCarousel({
        autoplay: true,
        items: 1,
        loop: true,
        dots: true,
        smartSpeed: 750,
        nav: true,
        navContainer: '.custom-nav',
        onInitialized: counter, //When the plugin has initialized.
        onTranslated: counter //When the translation of the stage has finished.
    });

    function counter(event) {
        var element = event.target; // DOM element, in this example .owl-carousel
        var items = event.item.count; // Number of items
        var item = event.item.index + 1; // Position of the current item

        // it loop is true then reset counter from 1
        if (item > items) {
            item = item - items
        }
        $('.counter').html("Slide " + item + " of " + items)
    }



    // Mask emails from spammers
    // $('.mask-email').each(function() {
    //     var $email = $(this);
    //     var css = $email.attr('class');
    //     // var label = $email.attr('title');
    //     var address = $email.text().replace(/\s*\[at\]\s*/, '@').replace(/\s*\[dot\]\s*/g, '.');
    //     var query = $email.data('query'); // get query string parameters if present
    //     var params = "";
    //     if (query != null) {
    //         params = query;
    //     }
    //     $email.html('<a href="mailto:' + address + params + '" class="' + css + '">' + address + '</a>');
    //     // clear em out
    //     $email.attr('class', '');
    //     $email.attr('data-query', '');
    // });

    $('.country-picker').on('changed.bs.select', function(e) {
        if (e.target.value) {
            return window.location.href = '/' + e.target.value;
        }

        return window.location.href = '/welcome';
    })

});

// Accept cookies
function cookiesPolicyBar() {
    // Check cookie
    if (cookie.get('AcceptButlinePrivacy') != "active") {
        $('#cookieAcceptBar').show();
        var cookieHeight = $('#cookieAcceptBar').height() + 20;
        $("#footer").css("padding-bottom", cookieHeight);

    }else{
        $("#footer").css("padding-bottom", "0");
    };

    //Assign cookie on click
    $('#cookieAcceptBarConfirm').on('click',function(){
        cookie.set('AcceptButlinePrivacy', 'active', { expires: 1 }); // cookie will expire in one day
        $('#cookieAcceptBar').hide();
        $("#footer").css("padding-bottom", "0");
    });
}





//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

    // Load cookies bar
    cookiesPolicyBar();

}

// scroll window to form error element and offset fixed header height
function scrollToFormError() {
    // console.log('scrollToFormError', window.location.hash);
    var windowWidth = $(window).width();
    var formStr = '#form-';
    // enquiry form error anchor offset
    if (window.location.hash && window.location.hash.indexOf(formStr) != -1) {

        var formEl = window.location.hash;
        if ($(formEl).length > 0) {

            // var offsetSize = $('.headerfixed').height();
            // console.log(window.location.hash+' '+offsetSize +' '+$(formEl).scrollTop());

            if (windowWidth > 767) {
                // offset
                var offsetSize = $('#main-nav').height() + 30;
                // animate scrollto
                $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 300);
            } else {
                $('html, body').animate({ scrollTop: $(formEl).offset().top }, 300);
            }

        }
    }
}